export default __webpack_public_path__ + "static/media/neet_rank_bg.66fe8a13.webp";